module.exports = __webpack_public_path__ + "media/images/techri-banner-b5f3ef3c5e2cdf9ee7cc304b6763e2fc.svg";